/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { ApiResponseGetHighwayUnpaidResponse } from '../models/ApiResponseGetHighwayUnpaidResponse';
import type { ApiResponsePayHighwayFeeResponse } from '../models/ApiResponsePayHighwayFeeResponse';
import type { ApiResponseRegisterVehicleResponse } from '../models/ApiResponseRegisterVehicleResponse';
import type { ApiResponseVoid } from '../models/ApiResponseVoid';
import type { PayHighwayFeeRequest } from '../models/PayHighwayFeeRequest';
import type { RegisterVehicleRequest } from '../models/RegisterVehicleRequest';
import type { UpdateVehicleRequest } from '../models/UpdateVehicleRequest';
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';
export class HighwayUnpaidService {
  constructor(public readonly httpRequest: BaseHttpRequest) {}
  /**
   * @returns ApiResponseVoid OK
   * @throws ApiError
   */
  public updateVehicle({
    authorization,
    puid,
    licensePlateNumber,
    requestBody,
  }: {
    authorization?: string,
    puid: string,
    licensePlateNumber: string,
    requestBody: UpdateVehicleRequest,
  }): CancelablePromise<ApiResponseVoid> {
    return this.httpRequest.request({
      method: 'PUT',
      url: '/public-service/highway-unpaid/vehicles/{licensePlateNumber}',
      path: {
        'licensePlateNumber': licensePlateNumber,
      },
      headers: {
        'Authorization': authorization,
      },
      query: {
        'puid': puid,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }
  /**
   * @returns ApiResponseVoid OK
   * @throws ApiError
   */
  public deleteVehicle({
    authorization,
    puid,
    licensePlateNumber,
  }: {
    authorization?: string,
    puid: string,
    licensePlateNumber: string,
  }): CancelablePromise<ApiResponseVoid> {
    return this.httpRequest.request({
      method: 'DELETE',
      url: '/public-service/highway-unpaid/vehicles/{licensePlateNumber}',
      path: {
        'licensePlateNumber': licensePlateNumber,
      },
      headers: {
        'Authorization': authorization,
      },
      query: {
        'puid': puid,
      },
    });
  }
  /**
   * @returns ApiResponseVoid OK
   * @throws ApiError
   */
  public updateVehicle1({
    authorization,
    puid,
    licensePlateNumber,
    requestBody,
  }: {
    authorization?: string,
    puid: string,
    licensePlateNumber: string,
    requestBody: UpdateVehicleRequest,
  }): CancelablePromise<ApiResponseVoid> {
    return this.httpRequest.request({
      method: 'PUT',
      url: '/public-service/highway-unpaid/vehicles/{licensePlateNumber}/',
      path: {
        'licensePlateNumber': licensePlateNumber,
      },
      headers: {
        'Authorization': authorization,
      },
      query: {
        'puid': puid,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }
  /**
   * @returns ApiResponseVoid OK
   * @throws ApiError
   */
  public deleteVehicle1({
    authorization,
    puid,
    licensePlateNumber,
  }: {
    authorization?: string,
    puid: string,
    licensePlateNumber: string,
  }): CancelablePromise<ApiResponseVoid> {
    return this.httpRequest.request({
      method: 'DELETE',
      url: '/public-service/highway-unpaid/vehicles/{licensePlateNumber}/',
      path: {
        'licensePlateNumber': licensePlateNumber,
      },
      headers: {
        'Authorization': authorization,
      },
      query: {
        'puid': puid,
      },
    });
  }
  /**
   * @returns ApiResponsePayHighwayFeeResponse OK
   * @throws ApiError
   */
  public payUnpaidFee({
    authorization,
    puid,
    licensePlateNumber,
    requestBody,
  }: {
    authorization?: string,
    puid: string,
    licensePlateNumber: string,
    requestBody: PayHighwayFeeRequest,
  }): CancelablePromise<ApiResponsePayHighwayFeeResponse> {
    return this.httpRequest.request({
      method: 'POST',
      url: '/public-service/highway-unpaid/{licensePlateNumber}',
      path: {
        'licensePlateNumber': licensePlateNumber,
      },
      headers: {
        'Authorization': authorization,
      },
      query: {
        'puid': puid,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }
  /**
   * @returns ApiResponsePayHighwayFeeResponse OK
   * @throws ApiError
   */
  public payUnpaidFee1({
    authorization,
    puid,
    licensePlateNumber,
    requestBody,
  }: {
    authorization?: string,
    puid: string,
    licensePlateNumber: string,
    requestBody: PayHighwayFeeRequest,
  }): CancelablePromise<ApiResponsePayHighwayFeeResponse> {
    return this.httpRequest.request({
      method: 'POST',
      url: '/public-service/highway-unpaid/{licensePlateNumber}/',
      path: {
        'licensePlateNumber': licensePlateNumber,
      },
      headers: {
        'Authorization': authorization,
      },
      query: {
        'puid': puid,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }
  /**
   * @returns ApiResponseRegisterVehicleResponse OK
   * @throws ApiError
   */
  public registerVehicle1({
    authorization,
    puid,
    requestBody,
  }: {
    authorization?: string,
    puid: string,
    requestBody: RegisterVehicleRequest,
  }): CancelablePromise<ApiResponseRegisterVehicleResponse> {
    return this.httpRequest.request({
      method: 'POST',
      url: '/public-service/highway-unpaid/vehicles',
      headers: {
        'Authorization': authorization,
      },
      query: {
        'puid': puid,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }
  /**
   * @returns ApiResponseRegisterVehicleResponse OK
   * @throws ApiError
   */
  public registerVehicle2({
    authorization,
    puid,
    requestBody,
  }: {
    authorization?: string,
    puid: string,
    requestBody: RegisterVehicleRequest,
  }): CancelablePromise<ApiResponseRegisterVehicleResponse> {
    return this.httpRequest.request({
      method: 'POST',
      url: '/public-service/highway-unpaid/vehicles/',
      headers: {
        'Authorization': authorization,
      },
      query: {
        'puid': puid,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }
  /**
   * @returns ApiResponseGetHighwayUnpaidResponse OK
   * @throws ApiError
   */
  public getHighwayUnpaid({
    authorization,
    puid,
  }: {
    authorization?: string,
    puid: string,
  }): CancelablePromise<ApiResponseGetHighwayUnpaidResponse> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/public-service/highway-unpaid',
      headers: {
        'Authorization': authorization,
      },
      query: {
        'puid': puid,
      },
    });
  }
  /**
   * @returns ApiResponseGetHighwayUnpaidResponse OK
   * @throws ApiError
   */
  public getHighwayUnpaid1({
    authorization,
    puid,
  }: {
    authorization?: string,
    puid: string,
  }): CancelablePromise<ApiResponseGetHighwayUnpaidResponse> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/public-service/highway-unpaid/',
      headers: {
        'Authorization': authorization,
      },
      query: {
        'puid': puid,
      },
    });
  }
}
